import React from 'react';

import i18n from 'util/i18n';

import { LEGAL, LEGAL_POLICE_ADDITIONAL_OFFENSES } from 'config/formSections/legal';

import Subsection from 'components/Section/shared/Subsection';
import connectSubsection from 'components/Section/shared/SubsectionConnector';

import { SF85P, SF85PS } from 'constants/formTypes';
import { isPVQForm } from 'helpers/form';
import BranchCollection from 'components/Form/BranchCollection';
import OtherOffense from './OtherOffense';

const sectionConfig = {
  key: LEGAL_POLICE_ADDITIONAL_OFFENSES.key,
  section: LEGAL.name,
  store: LEGAL.store,
  subsection: LEGAL_POLICE_ADDITIONAL_OFFENSES.name,
  storeKey: LEGAL_POLICE_ADDITIONAL_OFFENSES.storeKey,
};

export class OtherOffenses extends Subsection {
  constructor(props) {
    super(props);

    const {
      section, subsection, store, storeKey
    } = sectionConfig;

    this.section = section;
    this.subsection = subsection;
    this.store = store;
    this.storeKey = storeKey;
    this.formType = props.formType;
    this.updateList = this.updateList.bind(this);
    this.additionalOffenses = this.additionalOffenses.bind(this);
    this.otherOffenseBranch = this.otherOffenseBranch.bind(this);
  }

  updateList = (collection) => {
    this.props.onUpdate(this.storeKey, { List: collection });
  };

  otherOffenseBranch = () => <div> {this.additionalOffenses()} </div>;

  additionalOffenses = () => ([SF85P, SF85PS].includes(this.formType) && (
    <ul className="other-offenses">
      <li>{i18n.m('legal.police.para.otherOffense.third')}</li>
    </ul>
  )) || (
      <ul className="other-offenses">
        <li>{i18n.m('legal.police.para.otherOffense.first')}</li>
        <li>{i18n.m('legal.police.para.otherOffense.second')}</li>
        <li>{i18n.m('legal.police.para.otherOffense.third')}</li>
        <li>{i18n.m('legal.police.para.otherOffense.fourth')}</li>
        <li>{i18n.m('legal.police.para.otherOffense.fifth')}</li>
      </ul>
    );

  render() {
    const { requireLegalPoliceFirearms, requireLegalPoliceDrugs, errors, formType } = this.props;

    const collectionErrors = errors && errors.filter((e) => e.indexOf('List.branchCollection') === 0);

    const isPVQ = isPVQForm(formType);

    return isPVQ ? (
      <div
        className="section-content police-other-offenses"
        data-section={LEGAL.key}
        data-subsection={LEGAL_POLICE_ADDITIONAL_OFFENSES.key}
      >
        <h1 className="section-header">{i18n.t('legal.pvq.subsection.police.additionalOffenses')}</h1>
        <BranchCollection
          {...this.props.List}
          name="has_otheroffenses"
          label={i18n.t('legal.pvq.police.para.otherOffense.intro')}
          className="has-otheroffenses"
          warning
          appendLabel={i18n.t('legal.pvq.police.collection.appendOtherOffense')}
          appendSize="h4"
          /*appendContent={this.otherOffenseBranch()} */ // eslint-disable-line @typescript-eslint/unbound-method
          onUpdate={this.updateList} // eslint-disable-line @typescript-eslint/unbound-method
          scrollToBottom={this.props.scrollToBottom}
          required={this.props.required}
          onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
          scrollIntoView={this.props.scrollIntoView}
          /*content={this.additionalOffenses()}*/
          errors={collectionErrors}
          attribute="List"
        >
          <OtherOffense
            name="Item"
            addressBooks={this.props.addressBooks}
            dispatch={this.props.dispatch}
            bind
            defaultState={this.props.defaultState}
            onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
            required={this.props.required}
            scrollIntoView={this.props.scrollIntoView}
            requireLegalPoliceFirearms={requireLegalPoliceFirearms}
            requireLegalPoliceDrugs={requireLegalPoliceDrugs}
            formType={this.props.formType}
            attribute="List"
          />
        </BranchCollection>
      </div>
    )
      : (
        <div
          className="section-content police-other-offenses"
          data-section={LEGAL.key}
          data-subsection={LEGAL_POLICE_ADDITIONAL_OFFENSES.key}
        >
          <h1 className="section-header">{i18n.t('legal.subsection.police.additionalOffenses')}</h1>
          <BranchCollection
            {...this.props.List}
            name="has_otheroffenses"
            label={i18n.t('legal.police.para.otherOffense.intro')}
            className="has-otheroffenses"
            warning
            appendLabel={i18n.t('legal.police.collection.appendTitle')}
            appendSize="h4"
            appendContent={this.otherOffenseBranch()} // eslint-disable-line @typescript-eslint/unbound-method
            onUpdate={this.updateList} // eslint-disable-line @typescript-eslint/unbound-method
            scrollToBottom={this.props.scrollToBottom}
            required={this.props.required}
            onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
            scrollIntoView={this.props.scrollIntoView}
            content={this.additionalOffenses()}
            errors={collectionErrors}
            attribute="List"
          >
            <OtherOffense
              name="Item"
              addressBooks={this.props.addressBooks}
              dispatch={this.props.dispatch}
              bind
              defaultState={this.props.defaultState}
              onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
              required={this.props.required}
              scrollIntoView={this.props.scrollIntoView}
              requireLegalPoliceFirearms={requireLegalPoliceFirearms}
              requireLegalPoliceDrugs={requireLegalPoliceDrugs}
              attribute="List"
            />
          </BranchCollection>
        </div>
      );
  }
}

OtherOffenses.defaultProps = {
  onUpdate: () => { },
  onError: (value, arr) => arr,
  addressBooks: {},
  dispatch: () => { },
  defaultState: true,
  scrollToBottom: '',
  requireLegalPoliceFirearms: true,
  requireLegalPoliceDrugs: true,
  errors: [],
};

export default connectSubsection(OtherOffenses, sectionConfig);
